import CTABanner from '@/components/_organisms/CTABanner';
import { ModuleCtaBannerFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import gtm from '@/lib/gtm';
import { parseHeading, parseHtml } from '@/lib/parse-html';
import { FC } from 'react';

interface CTABannerModuleProps {
  props: CraftModuleFragment<ModuleCtaBannerFragment>;
}

const CTABannerModule: FC<CTABannerModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const primaryCta = getSingleLink(props.primaryCta);
  const secondaryCta = getSingleLink(props.secondaryCta);

  // At least one CTA is required
  if (!primaryCta) return null;

  const bannerHeading = props.heading;

  return (
    <CTABanner
      heading={parseHeading(bannerHeading)}
      paragraph={parseHtml(props.paragraph ?? null)}
      bannerStyle={(props.style as 'light' | 'dark') ?? 'light'}
      primaryCta={{
        text: primaryCta.text,
        href: primaryCta.url,
        onClick: () => {
          gtm.track('click', {
            element_type: 'link',
            element_label: `Primary CTA - ${primaryCta.text}`,
            location: `CTA Banner - ${bannerHeading}`,
          });
        },
      }}
      secondaryCta={
        secondaryCta
          ? {
              text: secondaryCta.text,
              href: secondaryCta.url,
              onClick: () => {
                gtm.track('click', {
                  element_type: 'link',
                  element_label: `Secondary CTA - ${secondaryCta.text}`,
                  location: `CTA Banner - ${bannerHeading}`,
                });
              },
            }
          : undefined
      }
    />
  );
};

export default CTABannerModule;
